/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryLeadScreenerLeadInfoRace
 */
export interface PalSubmissionListEntryLeadScreenerLeadInfoRace {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfoRace
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfoRace
     */
    name?: string;
}

/**
 * Check if a given object implements the PalSubmissionListEntryLeadScreenerLeadInfoRace interface.
 */
export function instanceOfPalSubmissionListEntryLeadScreenerLeadInfoRace(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryLeadScreenerLeadInfoRaceFromJSON(json: any): PalSubmissionListEntryLeadScreenerLeadInfoRace {
    return PalSubmissionListEntryLeadScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryLeadScreenerLeadInfoRace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PalSubmissionListEntryLeadScreenerLeadInfoRaceToJSON(value?: PalSubmissionListEntryLeadScreenerLeadInfoRace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

